import React, { useContext } from 'react'

import { UserData } from '../Contexts'

export default function Currency() {
    const [userCtx] = useContext(UserData)
   const currencySymbol=userCtx.user.is_foundation_account?"$":"₪"
  return (
    currencySymbol
  )
}

export function currency(userCtx){

    const currencySymbol=userCtx.user.is_foundation_account?"$":"₪"
   return (
     currencySymbol
   )
}